<template>
  <b-modal id="clinic-show-expense" class="clinic-show-expense" ref="modal" :title="dialog_title" hide-footer>

    <div class="form-group row">

      <div class="col-12">
        <h5>DATOS DEL GASTO</h5>
      </div>

      <div class="col-sm-6">
        <select v-model="provider_family_id" class="custom-select" id="clinic_expense_family">
          <option :value="null">Elige ...</option>
          <option :value="family.id" v-for="family in this.clinic.provider_families" :key="family.id">
            {{ family.name }}
          </option>
        </select>
        <label class="wabident-info" for="clinic_expense_family">Tipo de Gasto</label>
      </div>
      <div class="col-sm-6">
        <input v-model="expense_date" id="clinic_expense_date" type="date" class="form-control" />
        <label class="wabident-info" for="clinic_expense_date">Fecha</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-6">
        <input v-model="concept" id="clinic_expense_concept" type="text" class="form-control" />
        <label class="wabident-info" for="clinic_expense_concept">Concepto</label>
      </div>
      <div class="col-sm-3">
        <input v-model="amount" id="clinic_expense_amount" type="number" class="form-control" />
        <label class="wabident-info" for="clinic_expense_amount">Importe</label>
      </div>
      <div class="col-sm-3">
        <select id="clinic_expense_vat" v-model="vat" class="custom-select">
          <option :value="null">Seleccionar ...</option>
          <option v-for="tax in clinic.taxes" :value="parseInt(tax.value)" :key="tax.id">{{ tax.name }}</option>
        </select>
        <label class="wabident-info" for="clinic_expense_vat">IVA</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12">
        <h5>ARCHIVO DE FACTURA</h5>
      </div>

      <div v-if="is_editing && invoice_filename" class="col-12 my-2">
        <strong>ARCHIVO ACTUAL:</strong> <a class="btn-link" :href="expense_download_url" target="_blank">{{
          invoice_filename }}</a>
      </div>

      <div class="col-12">
        <b-form-file v-model="file" :state="Boolean(file)" placeholder="Factura (Opcional)" class="wabident-file-input"
          :disabled="is_loading"></b-form-file>
      </div>
    </div>

    <div class="form-group row">
      <div class="col text-center">
        <button @click="submit" :disabled="is_loading" type="button" class="btn btn-primary btn-wabident">
          <span v-if="is_editing">Modificar</span>
          <span v-else>Crear </span>
          <i v-if="is_loading" class="fa fa-spin fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      is_loading: false,
      expense_id: null,
      provider_family_id: null,
      clinic_provider_id: null,
      expense_date: null,
      concept: null,
      amount: 0,
      vat: 0,
      invoice_filename: null,
      file: null,
      file_data: null,
    }
  },
  computed: {
    expense_download_url() {
      if (!this.expense_id) {
        return '';
      }
      return `/clinic/expenses/${this.expense_id}/invoice`;
    },
    is_editing() {
      return this.expense_id;
    },
    dialog_title() {
      return this.expense_id ? 'Editar Gasto' : 'Crear Gasto';
    },
    ...mapGetters(['clinic', 'errorwindow', 'msgwindow'])
  },
  watch: {
    file(value) {
      if (value) {
        var reader = new FileReader();
        reader.readAsDataURL(value);
        reader.onload = () => {
          this.invoice_filename = value.name;
          this.file_data = reader.result;
        };
        reader.onerror = (error) => {
          console.log('Error reading file data: ', error);
        };

      } else {
        this.invoice_filename = null;
        this.file_data = null;
      }
    }
  },
  methods: {
    showNew() {
      this.is_loading = false;
      this.expense_id = null;
      this.provider_family_id = null;
      this.clinic_provider_id = null;
      this.expense_date = new Date().toISODate();
      this.concept = '';
      this.amount = 0;
      this.vat = 0;
      this.invoice_filename = null;
      this.file = null;
      this.file_data = null;

      this.$refs.modal.show();
    },
    showEdit(expense) {
      this.is_loading = false;
      this.expense_id = expense.id;
      this.provider_family_id = expense.provider_family_id;
      this.clinic_provider_id = expense.clinic_provider_id;
      this.expense_date = expense.expense_date;
      this.concept = expense.concept;
      this.amount = expense.amount;
      this.vat = Math.round(expense.vat);
      this.invoice_filename = expense.invoice_filename;

      this.file = null;
      this.file_data = null;
      this.$refs.modal.show();
    },
    validateExpense() {
      return true;
    },
    submit() {
      if (!this.validateExpense()) return;
      this.doSubmit();
    },
    doSubmit() {
      if (this.is_loading) {
        return;
      }

      let params = {
        provider_family_id: this.provider_family_id,
        clinic_provider_id: this.clinic_provider_id,
        expense_date: this.expense_date,
        concept: this.concept,
        amount: this.amount,
        vat: this.vat,
        invoice_filename: this.invoice_filename,
        invoice_data: this.file_data,
      };

      if (this.is_editing) {
        params._method = 'patch';
      }

      const uri = this.is_editing ? `/clinic/expenses/${this.expense_id}` : `/clinic/expenses`;
      axios
        .post(uri, params)
        .then((response) => {
          this.$emit("submit");
          this.msgwindow.success("Añadido con éxito");
          this.$refs.modal.hide();
        })
        .catch((err) => {
          this.msgwindow.error("Error añadiendo!");
          this.$refs.modal.hide();
        })
        .then(() => {
          this.is_loading = false;
        });
    }
  }
}
</script>


<style lang="scss">
#clinic-show-expense {
  .modal-dialog {
    max-width: 768px;
  }
}
</style>
